<template>
  <!-- 每月进销存 -->
  <div class="table_container">
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 车型 -->
      <el-table-column
        prop="carModel"
        label="车型"
        min-width="120px"
        align="center"
        class-name="disabled_column"
      />
      <!-- 查询年 -->
      <el-table-column :label="`${Number(queryParams.years)}年`" align="center">
        <!-- 实销 -->
        <el-table-column
          v-for="(item, index) in monthList"
          :key="index"
          :label="item.month"
          align="center"
        >
          <!-- 实销/批发 -->
          <el-table-column
            :prop="item.shixiaoField"
            label="实销/批发"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
          <!-- 库存 -->
          <el-table-column
            :prop="item.kuCunField"
            label="库存"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
          <!-- 发运在途 -->
          <el-table-column
            :prop="item.zaiTuField"
            label="发运在途"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
          <!-- 接单 -->
          <el-table-column
            :prop="item.orderField"
            label="接单"
            min-width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                v-if="
                  editField === item.orderField && editIndex === scope.$index
                "
                id="focusRef"
                v-model="scope.row[item.orderField]"
                class="number_input"
                :controls="false"
                :precision="0"
                size="mini"
                style="width: 100%"
                @blur="confirmEdit"
                @keyup.enter.native="confirmEdit"
              >
              </el-input-number>
              <div v-else>
                {{ scope.row[item.orderField] }}
              </div>
            </template>
          </el-table-column>
          <!-- 库销比 -->
          <el-table-column
            :prop="item.kuXiaoBiField"
            label="库销比"
            min-width="90px"
            align="center"
            class-name="disabled_column"
          />
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateMonthlyPurchaseSaleStockApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1, // 编辑行索引
      monthList: [
        {
          month: "1月",
          shixiaoField: "oneShixiao",
          kuCunField: "oneKuCun",
          zaiTuField: "oneZaiTu",
          orderField: "oneOrder",
          kuXiaoBiField: "oneKuXiaoBi"
        },
        {
          month: "2月",
          shixiaoField: "twoShixiao",
          kuCunField: "twoKuCun",
          zaiTuField: "twoZaiTu",
          orderField: "twoOrder",
          kuXiaoBiField: "twoKuXiaoBi"
        },
        {
          month: "3月",
          shixiaoField: "threeShixiao",
          kuCunField: "threeKuCun",
          zaiTuField: "threeZaiTu",
          orderField: "threeOrder",
          kuXiaoBiField: "threeKuXiaoBi"
        },
        {
          month: "4月",
          shixiaoField: "fourShixiao",
          kuCunField: "fourKuCun",
          zaiTuField: "fourZaiTu",
          orderField: "fourOrder",
          kuXiaoBiField: "fourKuXiaoBi"
        },
        {
          month: "5月",
          shixiaoField: "fiveShixiao",
          kuCunField: "fiveKuCun",
          zaiTuField: "fiveZaiTu",
          orderField: "fiveOrder",
          kuXiaoBiField: "fiveKuXiaoBi"
        },
        {
          month: "6月",
          shixiaoField: "sixShixiao",
          kuCunField: "sixKuCun",
          zaiTuField: "sixZaiTu",
          orderField: "sixOrder",
          kuXiaoBiField: "sixKuXiaoBi"
        },
        {
          month: "7月",
          shixiaoField: "sevenShixiao",
          kuCunField: "sevenKuCun",
          zaiTuField: "sevenZaiTu",
          orderField: "sevenOrder",
          kuXiaoBiField: "sevenKuXiaoBi"
        },
        {
          month: "8月",
          shixiaoField: "eightShixiao",
          kuCunField: "eightKuCun",
          zaiTuField: "eightZaiTu",
          orderField: "eightOrder",
          kuXiaoBiField: "eightKuXiaoBi"
        },
        {
          month: "9月",
          shixiaoField: "nineShixiao",
          kuCunField: "nineKuCun",
          zaiTuField: "nineZaiTu",
          orderField: "nineOrder",
          kuXiaoBiField: "nineKuXiaoBi"
        },
        {
          month: "10月",
          shixiaoField: "tenShixiao",
          kuCunField: "tenKuCun",
          zaiTuField: "tenZaiTu",
          orderField: "tenOrder",
          kuXiaoBiField: "tenKuXiaoBi"
        },
        {
          month: "11月",
          shixiaoField: "elevenShixiao",
          kuCunField: "elevenKuCun",
          zaiTuField: "elevenZaiTu",
          orderField: "elevenOrder",
          kuXiaoBiField: "elevenKuXiaoBi"
        },
        {
          month: "12月",
          shixiaoField: "twelveShixiao",
          kuCunField: "twelveKuCun",
          zaiTuField: "twelveZaiTu",
          orderField: "twelveOrder",
          kuXiaoBiField: "twelveKuXiaoBi"
        }
      ] // 月度
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateMonthlyPurchaseSaleStockApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
